import { useState } from 'react'
import { Box, Flex } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'

import { EditTransactionModal } from '@/components/EditTransactionModal/EditTransactionModal'
import { ScrollArea } from '@/components/ScrollArea/ScrollArea'
import { Text } from '@/components/Text/Text'
import type { TransactionsListProps } from '@/components/TransactionsList/TransactionsListProps'
import { TransactionsListItem } from '@/components/TransactionsListItem/TransactionsListItem'
import { UpdateAllTransactionsModal } from '@/components/UpdateAllTransactionsModal/UpdateAllTranasactionsModal'

import type {
  BulkEditTransactionsDTO,
  MappedTransaction,
} from '@/__generated__/requests'

export function TransactionsList({
  transactions: rawTransactions,
  type,
}: TransactionsListProps) {
  const transactions = rawTransactions?.filter(
    transaction => Math.abs(transaction.amount) >= 1,
  )

  const [currentTransaction, setCurrentTransaction] = useState<
    MappedTransaction | undefined
  >(undefined)
  const [opened, { close, open }] = useDisclosure()
  const [allTransactionsOpened, setAllTransactionsOpened] =
    useState<boolean>(false)
  const [otherTransactions, setOtherTransactions] = useState<
    BulkEditTransactionsDTO | undefined
  >(undefined)

  const handleEdit = (transaction: MappedTransaction) => {
    setCurrentTransaction(transaction)

    open()
  }

  if (transactions?.length === 0 || !transactions) {
    return (
      <Box>
        <Text>No transactions found</Text>
        <Text variant="body_4_gray">
          If you added new account recently, please refresh this page later.
        </Text>
      </Box>
    )
  }

  return (
    <Box>
      <ScrollArea
        h={{
          base: transactions?.length > 5 ? 500 : 'auto',
          sm: transactions?.length > 13 ? 1000 : 'auto',
        }}
        scrollbars="xy"
      >
        <Flex direction="column" gap={16}>
          {transactions?.map(transaction => (
            <TransactionsListItem
              key={transaction.id}
              onEdit={handleEdit}
              transaction={transaction}
              type={type}
            />
          ))}
        </Flex>
      </ScrollArea>

      <EditTransactionModal
        onClose={close}
        onTransactionsFound={setOtherTransactions}
        openAllTransactions={() => setAllTransactionsOpened(true)}
        opened={opened}
        transaction={currentTransaction}
        type={type}
      />

      <UpdateAllTransactionsModal
        onClose={() => setAllTransactionsOpened(false)}
        opened={allTransactionsOpened}
        otherTransactions={otherTransactions}
      />
    </Box>
  )
}
